// extracted by mini-css-extract-plugin
export default {"transactionEventsTable":"transaction-events-table-container__transaction-events-table__dcI9u"};